import { Component, OnInit, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'app/services/user.service';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';

@Component({
    selector: 'verify-email',
    templateUrl: './verify-email.component.html',
    styleUrls: ['./verify-email.component.scss']
})

export class VerifyEmailComponent implements OnInit ,AfterViewInit {
    url: string;
    isVerified: boolean = false;
    isError: boolean = false;
    errorMsg: string = "";
    constructor(private route: ActivatedRoute, private userService: UserService
        , private cdRef: ChangeDetectorRef,private ecoDocsTitleService: EcoDocsTitleService) {
        this.url = this.route.snapshot.queryParams.verify_url;

    }

    ngOnInit() {
        this.ecoDocsTitleService.setTitle('Verify Email', false);  
    }

    ngAfterViewInit(){
        this.userService.verifyMail(this.url).subscribe(v => {
    
            this.isVerified = true;
            this.isError = false;
            this.cdRef.detectChanges();

        }, err => {
         
            this.isVerified = false;
            this.isError = true;
            if (err.status === 422)
                this.errorMsg = err.message;
            else
                this.errorMsg = "Failed to verify email address!"
            this.cdRef.detectChanges();

        });
    }
}
